import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Radio} from '@material-ui/core';
import {
    getEoneStList,
    getPlatfmcodeList,
    getStInforList,
    saveB2bPlatform,
    updateB2bPlatform,
    editB2bPlatform,
} from 'Actions/b2bManagement';
import {getSCList} from 'Actions/userCenter';
import {openNotification} from 'Actions/notification';
import BasicButton from 'Components/common/BasicButton';
import BasicOnInput from 'Components/common/BasicOnInput';
import Input from 'Components/common/Input';
import Select from 'Components/common/Select';
import BasicTextArea from 'Components/common/BasicTextArea';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';
import {loadLanguage} from 'Utils/jwtUtil';
import Header from 'Components/common/Header';
import ChipTag from 'Components/common/ChipTag';
import Anchor from 'Components/common/Anchor';
// Icons
import {KeyboardArrowRight} from '@material-ui/icons';

class AddB2bPlatform extends Component {
    state = {
        shipTo: '',
        shipToList: [],
        allShipToList: [],
        tagValue: '',
        contactEmail: '',
        loading: false,
        description: '',
        platformId: '',
        platformDataList: [],
        subject: '',
        platformShipto: '',
        enableWop: 'N',
        splitByLine: 'Y',
        chipData: [],
        scName: '',
        scFlag: false,
        platformFlag: false,
        scId: '',
        scList: [],
        hiddleSubjectAndSC: false,
        remarkNum: 0,
    };

    async componentDidMount() {
        const {localData} = this.props;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        const item = this.props.location.state.item;
        const type =
            this.props.location.state.type ||
            routerState.currentB2bAction ||
            '';
        const platfmflag = await this.getPlatfmcodeList();
        if (platfmflag == 'success') {
            if (item && item.stNumber) {
                this.getB2bConfigSPList(item.stNumber, type);
                this.setState({
                    chipData:
                        item.contactEmail &&
                        item.contactEmail.length > 0 &&
                        item.contactEmail.split(';'),
                });
            }
        }

        if (
            JSON.stringify(routerState) !== '{}' &&
            routerState.moduleFlag === 'b2bSelectCustomer'
        ) {
            if (localData.roleType === 1 || localData.roleType === 3) {
                if (
                    routerState.shipToNo !== 'undefined' &&
                    routerState.shipToNo
                ) {
                    this.getShipToList(
                        routerState.shipToNo.trim(),
                        routerState.subject,
                    );
                }
            }
            if (type === 'edit') {
                let currentEditOtherData = routerState.currentEditOtherData;

                this.setState({
                    shipTo: routerState.shipToNo,
                    subject: routerState.subject,
                    enableWop: currentEditOtherData.enableWop,
                    platformShipto: currentEditOtherData.platformShipto,
                    platformId: currentEditOtherData.platformId,
                    splitByLine: currentEditOtherData.splitByLine,
                    description: currentEditOtherData.description,
                    contactEmail: currentEditOtherData.contactEmail,
                    chipData: currentEditOtherData.contactEmail,
                });
            } else if (type === 'add') {
                this.setState({
                    shipTo: routerState.shipToNo,
                    subject: routerState.subject,
                });
            }
        } else {
            if (type === 'add') {
                this.setState({
                    hiddleSubjectAndSC: true,
                });
            }
        }
    }

    inputChange = (title, value) => {
        this.setState({[title]: value});
    };
    getShipToList = (stNumber, subject) => {
        this.setState(
            {
                shipToList: [],
            },
            () => {
                let currentSubject = subject;
                this.getB2bConfigSPList(stNumber);
                this.setState({
                    subject: currentSubject,
                });
            },
        );
    };

    getEditB2bData = (id) => {
        this.props.editB2bPlatform(id).then((res) => {
            if (res.status === 'success') {
                const data = res.data;

                this.setState({
                    shipTo: data.stNumber,
                    subject: data.stAlpha,
                    enableWop: data.enableWop,
                    splitByLine: data.splitByLine,
                    description: data.description,
                    contactEmail:
                        data.contactEmail &&
                        data.contactEmail.length > 0 &&
                        data.contactEmail.split(';'),
                    platformShipto: data.platformStCode,
                    platformId: data.platformCode,
                    scName: data.supplyCenterName,
                    scId: data.supplyCenterId,
                    remarkNum: data.description.length,
                });
            }
        });
    };

    getB2bConfigSPList = (stNumber, type) => {
        const {localData} = this.props;
        let scId = undefined;
        const items = this.props.location.state.item;
        const id =
            (this.props.location.state.item &&
                this.props.location.state.item.id) ||
            '';
        this.props
            .getSCList(stNumber)
            .then((scList) => {
                scList &&
                    scList.data &&
                    scList.data.forEach((item) => {
                        this.setState(
                            {
                                scList: scList.data,
                            },
                            () => {
                                if (
                                    type == 'edit' &&
                                    id !== null &&
                                    id !== undefined
                                ) {
                                    this.getEditB2bData(id);
                                }
                            },
                        );
                        if (item.id === localData.defaultScId) {
                            scId = item.id;
                            this.setState({
                                scId,
                            });
                        } else {
                            this.setState({
                                scId: scList.data[0].id,
                            });
                        }
                    });
                if (scList && scList.data.length == 0) {
                    let SCList = [];
                    SCList.push({
                        name: items.supplyCenterName,
                        id: items.supplyCenterId,
                    });
                    this.setState({
                        scList: SCList,
                    });
                    if (type == 'edit' && id !== null && id !== undefined) {
                        this.getEditB2bData(id);
                        this.setState({
                            platformId: items.platformCode,
                        });
                    }
                }
            })
            .catch((err) => {
                if (err.status === 'invalid_shipToNum') {
                    this.props.openNotification(
                        T('b2b_management_platform_shipto_invalid'),
                        'danger',
                    );
                }
                if (type == 'edit' && id !== null && id !== undefined) {
                    this.props.editB2bPlatform(id).then((res) => {
                        if (res.status === 'success') {
                            const data = res.data;
                            this.setState({
                                shipTo: items.stNumber,
                                subject: items.stAlpha,
                                enableWop: items.enableWop,
                                splitByLine: items.splitByLine,
                                description: items.description,
                                contactEmail:
                                    items.contactEmail &&
                                    data.contactEmail.length > 0 &&
                                    data.contactEmail.split(';'),
                                platformShipto: items.platformStCode,
                                platformId: items.platformCode,
                                scName: items.supplyCenterName,
                                scId: items.supplyCenterId,
                            });
                        }
                    });
                }
            });
    };

    getPlatfmcodeList = async () => {
        const flag = await this.props.getPlatfmcodeList().then((res) => {
            if (res && res.status === 'success' && res.data.length > 0) {
                let platformArry = [];
                res.data.forEach((platformItem, platformIndex) => {
                    platformArry.push({
                        id: platformItem.key,
                        name: platformItem.value,
                    });
                });
                this.setState({
                    platformDataList: platformArry,
                });
            }
            return 'success';
        });
        return flag;
    };

    focusShipToInput = () => {
        this.setState({
            shipToList: this.state.allShipToList,
        });
    };

    handleTextArea = (name, value) => {
        if (value && value.length > 0) {
            let num = value && value.length;
            if (num >= 200) {
                num = 200;
            }
            this.setState({
                remarkNum: num,
                description: value,
            });
        }
    };

    clearInput = () => {
        this.setState({
            remarkNum: 0,
            description: '',
        });
    };

    handleOnPlatformShiptoInput = (name, value) => {
        this.setState({platformShipto: value});
    };

    handleChangeRadio = (event) => {
        let value = event.target.value;
        if (value === 'N') {
            this.setState({
                splitByLine: 'N',
            });
        } else {
            this.setState({
                splitByLine: 'Y',
            });
        }
    };

    handleChangeEnableWopRadio = (event) => {
        let value = event.target.value;
        if (value === 'N') {
            this.setState({
                enableWop: 'N',
            });
        } else {
            this.setState({
                enableWop: 'Y',
            });
        }
    };

    submitSave = () => {
        this.setState({loading: true});
        const {
            scId,
            shipTo,
            subject,
            splitByLine,
            platformId,
            platformShipto,
            enableWop,
            contactEmail,
            description,
        } = this.state;
        if (!shipTo) {
            this.props.openNotification(
                T('b2b_management_shipto_not_null'),
                'danger',
            );
        } else if (!subject) {
            this.props.openNotification(
                T('b2b_management_subject_not_null'),
                'danger',
            );
        } else if (!scId) {
            this.props.openNotification(
                T('b2b_management_supply_center_not_null'),
                'danger',
            );
        } else if (!platformId) {
            this.props.openNotification(
                T('b2b_management_platform_not_null'),
                'danger',
            );
        } else if (!platformShipto || !platformShipto.trim()) {
            this.props.openNotification(
                T('b2b_management_platform_shipto_not_null'),
                'danger',
            );
        } else {
            const params = {};
            params.supplyCenterId = scId;
            params.stNumber = shipTo.trim();
            params.stAlpha = subject;
            params.platformCode = platformId;
            params.platformStCode = platformShipto;
            params.splitByLine = splitByLine;
            params.enableWop = enableWop;
            params.description = description;
            params.contactEmail =
                (contactEmail &&
                    contactEmail.length > 0 &&
                    contactEmail.join(';')) ||
                '';
            let routerState = util.getRouterState(
                this.props.history.location.state,
            );
            const type =
                this.props.location.state.type || routerState.currentB2bAction;
            const id =
                this.props.location.state.item &&
                this.props.location.state.item.id;
            if (id) {
                params.id = id;
            } else {
                if (
                    type === 'edit' &&
                    typeof routerState.currentId !== 'undefined'
                ) {
                    params.id = routerState.currentId;
                }
            }

            if (type === 'add') {
                this.props
                    .saveB2bPlatform(params)
                    .then((res) => {
                        if (res && res.status === 'success') {
                            this.setState({loading: false});
                            this.props.history.push('/b2bPlatformList');
                            this.props.openNotification(
                                T('b2b_management_save_success'),
                                'success',
                            );
                        }
                    })
                    .catch((res) => {
                        if (res && res.message) {
                            if (
                                res.message ===
                                    'duplicate PlatForm ST Number' ||
                                res.message === 'verification_error'
                            ) {
                                this.props.openNotification(
                                    T(
                                        'b2b_management_platform_shipto_duplicate',
                                    ),
                                    'danger',
                                );
                            } else if (res.message === 'invalid ST Number') {
                                this.props.openNotification(
                                    T('b2b_management_platform_shipto_invalid'),
                                    'danger',
                                );
                            } else if (
                                res.message ===
                                'platformStCode must not be blank'
                            ) {
                                this.props.openNotification(
                                    T(
                                        'b2b_management_platform_shipto_not_null',
                                    ),
                                    'danger',
                                );
                            }
                        }
                    });
            } else if (type === 'edit') {
                this.props
                    .updateB2bPlatform(params)
                    .then((res) => {
                        if (res && res.status === 'success') {
                            this.setState({loading: false});
                            this.props.history.push(`/b2bPlatformList`, {
                                type: 'list',
                            });
                            this.props.openNotification(
                                T('b2b_management_save_success'),
                                'success',
                            );
                        }
                    })
                    .catch((res) => {
                        if (res && res.message) {
                            if (
                                res.message ===
                                    'duplicate PlatForm ST Number' ||
                                res.message === 'verification_error'
                            ) {
                                this.props.openNotification(
                                    T(
                                        'b2b_management_platform_shipto_duplicate',
                                    ),
                                    'danger',
                                );
                            } else if (res.message === 'invalid ST Number') {
                                this.props.openNotification(
                                    T('b2b_management_platform_shipto_invalid'),
                                    'danger',
                                );
                            } else if (
                                res.message ===
                                'platformStCode must not be blank'
                            ) {
                                this.props.openNotification(
                                    T(
                                        'b2b_management_platform_shipto_not_null',
                                    ),
                                    'danger',
                                );
                            }
                        }
                    });
            }
        }
    };

    goBack = () => {
        this.props.history.push(`/b2bPlatformList`, {type: 'list'});
    };

    handleInput = (value) => {
        this.setState({
            tagValue: value,
        });
    };

    addHandleBtn = (data, type) => {
        //删除外部存在的tag
        if (typeof data === 'string' && type === 'delete') {
            this.setState((state) => {
                const chipData = [...state.chipData];
                const chipToDelete = chipData.indexOf(data);
                chipData.splice(chipToDelete, 1);

                const contactEmail = [...state.contactEmail];
                const emailDelete = contactEmail.indexOf(data);
                contactEmail.splice(emailDelete, 1);
                return {chipData, contactEmail};
            });
        } else if (type === 'add') {
            const {chipData} = this.state;
            let chip = chipData || [];
            let email = [...chip, ...data];
            this.setState({
                tagValue: '',
                contactEmail: email,
            });
        }
    };

    handleSelectChange = (item) => this.setState({scId: item.id});
    handleSelectPlatformChange = (item) => this.setState({platformId: item.id});

    goToSelectCustomerInfor = () => {
        if (
            this.props.location.state.type === 'add' ||
            this.props.location.state.currentB2bAction === 'add'
        ) {
            this.props.history.push('/selectCustomer/', {
                roleType: this.props.localData.roleType,
                moduleFlag: 'b2bPlatform',
                b2bPlatformAction:
                    this.props.location.state.type ||
                    this.props.location.state.currentB2bAction,
            });
        } else if (
            this.props.location.state.type === 'edit' ||
            this.props.location.state.currentB2bAction === 'edit'
        ) {
            const {
                splitByLine,
                platformId,
                platformShipto,
                enableWop,
                contactEmail,
                description,
            } = this.state;
            let editOtherData = {
                platformId: platformId,
                platformShipto: platformShipto,
                splitByLine: splitByLine,
                enableWop: enableWop,
                contactEmail: contactEmail,
                description: description,
            };
            const id =
                this.props.location.state.item &&
                this.props.location.state.item.id;
            this.props.history.push('/selectCustomer/', {
                roleType: this.props.localData.roleType,
                moduleFlag: 'b2bPlatform',
                b2bPlatformAction:
                    this.props.location.state.type ||
                    this.props.location.state.currentB2bAction,
                paramsId: id || this.props.location.state.currentId,
                editOtherData: editOtherData,
            });
        }
    };

    render() {
        const {
            chipData,
            hiddleSubjectAndSC,
            shipTo,
            scId,
            scList,
            platformId,
            platformDataList,
            subject,
            platformShipto,
            enableWop,
            splitByLine,
            tagValue,
            description,
            scName,
            remarkNum,
        } = this.state;
        const isSave = false;
        let lang = loadLanguage();
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        const type =
            this.props.location.state.type || routerState.currentB2bAction;

        console.log('platformId', platformId);
        console.log('platformDataList', platformDataList);

        return (
            <div className="b2b-platform-save">
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <Grid
                        className="page-title-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-title" item xs={11}>
                            <span>{T('b2b_management_config')}</span>
                        </Grid>
                    </Grid>
                </Header>
                <div className="content">
                    <section className="content-box b2b-management-basicselect">
                        <Grid
                            container
                            spacing={0}
                            justify={'center'}
                            className="transfer-to-container">
                            <Grid item xs={12} className="b2b-platform-shipto">
                                <label className="required-label">*</label>
                                <label>{T('shipTo')}</label>
                                <Input
                                    type="text"
                                    title="shipTo"
                                    value={shipTo}
                                    onChange={this.inputChange}
                                    placeholder={T(
                                        'b2b_management_please_select_account',
                                    )}
                                />

                                <div onClick={this.goToSelectCustomerInfor}>
                                    <KeyboardArrowRight />
                                </div>
                            </Grid>
                            {!hiddleSubjectAndSC ? (
                                <Grid
                                    item
                                    xs={12}
                                    className="b2b-platform-content no-required-laebl">
                                    {/* <label className="required-label">*</label> */}
                                    <Grid
                                        item
                                        xs={12}
                                        className="b2b-platform-subject-container">
                                        <div className="b2b-platform-title">
                                            <label>{T('order_subject')}</label>
                                        </div>
                                        <p className="b2b-platform-read-only">
                                            {subject}
                                        </p>
                                    </Grid>
                                </Grid>
                            ) : null}
                            {!hiddleSubjectAndSC ? (
                                <Grid
                                    item
                                    xs={12}
                                    className="b2b-platform-content no-required-laebl">
                                    {/* <label className="required-label">*</label> */}
                                    <label>{T('backup_supply_center')}</label>
                                    {scList.length > 0 ? (
                                        <Select
                                            className="select"
                                            value={scId}
                                            placeholder={T(
                                                'backup_supply_center_placeholder',
                                            )}
                                            data={scList}
                                            displayKey="name"
                                            valueKey="id"
                                            onChange={this.handleSelectChange}
                                            options={{
                                                icon: {
                                                    show: true,
                                                    color: '#E82D38',
                                                },
                                            }}
                                        />
                                    ) : null}
                                </Grid>
                            ) : null}
                            <Grid item xs={12} className="b2b-platform-content">
                                <label className="required-label">*</label>
                                <label>{T('b2b_management_platform')}</label>
                                {platformDataList ? (
                                    <Select
                                        className="select"
                                        value={platformId}
                                        placeholder={T(
                                            'b2b_management_please_select_platform',
                                        )}
                                        data={platformDataList}
                                        displayKey="name"
                                        valueKey="id"
                                        onChange={
                                            this.handleSelectPlatformChange
                                        }
                                        options={{
                                            icon: {
                                                show: true,
                                                color: '#E82D38',
                                            },
                                        }}
                                    />
                                ) : null}
                            </Grid>

                            <Grid item xs={12} className="b2b-platform-content">
                                <label className="required-label">*</label>
                                <label>{T('platformShipto')}</label>
                                <Input
                                    type="text"
                                    value={platformShipto}
                                    title="platformShipto"
                                    onChange={this.handleOnPlatformShiptoInput}
                                    placeholder={T(
                                        'b2b_management_please_select_platform_shipto',
                                    )}
                                />
                            </Grid>
                            <Grid
                                className="b2b-config-container"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid
                                    className="b2b-config-method-grid"
                                    item
                                    xs={3}>
                                    <label className="required-label">*</label>
                                    <span className="delivery-method-label">
                                        {T('b2b_management_use_wop')}
                                    </span>
                                </Grid>
                                <Grid
                                    className="b2b-config-method-radio"
                                    item
                                    xs={9}>
                                    <Radio
                                        checked={enableWop === 'Y'}
                                        onChange={
                                            this.handleChangeEnableWopRadio
                                        }
                                        value={'Y'}
                                    />{' '}
                                    {T('b2b_management_use')}
                                    <Radio
                                        checked={enableWop === 'N'}
                                        onChange={
                                            this.handleChangeEnableWopRadio
                                        }
                                        value={'N'}
                                    />{' '}
                                    {T('b2b_management_not_use')}
                                </Grid>
                            </Grid>
                            <Grid
                                className="b2b-config-container"
                                container
                                spacing={0}
                                justify={'space-evenly'}>
                                <Grid
                                    className="b2b-config-method-grid"
                                    item
                                    xs={3}>
                                    <label className="required-label">*</label>
                                    <span className="delivery-method-label">
                                        {T(
                                            'b2b_management_split_order_methods',
                                        )}
                                    </span>
                                </Grid>
                                <Grid
                                    className="b2b-config-method-radio"
                                    item
                                    xs={9}>
                                    <Radio
                                        checked={splitByLine === 'Y'}
                                        onChange={this.handleChangeRadio}
                                        value={'Y'}
                                    />{' '}
                                    {T(
                                        'b2b_management_supply_center_inventory_split_order',
                                    )}
                                    <Radio
                                        checked={splitByLine === 'N'}
                                        onChange={this.handleChangeRadio}
                                        value={'N'}
                                    />{' '}
                                    {T(
                                        'b2b_management_customer_PO_number_split_order',
                                    )}
                                </Grid>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className="b2b_management_email no-required-laebl">
                                {
                                    <ChipTag
                                        title="email"
                                        placeholder={T(
                                            'b2b_management_input_add_email',
                                        )}
                                        required={true}
                                        checkEmail={true}
                                        inputValid={this.handleInput}
                                        value={tagValue}
                                        btnValue="host_abnormal_add"
                                        tagData={chipData}
                                        handleBtn={this.addHandleBtn}
                                    />
                                }
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className="b2b-description-container no-required-laebl">
                                <BasicTextArea
                                    type="text"
                                    title={'b2b_management_description'}
                                    inputValid={this.handleTextArea}
                                    defalutValue={description}
                                    clearInput={this.clearInput}
                                    maxlength={200}
                                    value={description}
                                    placeholder={T(
                                        'b2b_management_input_description',
                                    )}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className="b2b-reason-prompt-message">
                                ({remarkNum}/200)
                            </Grid>
                        </Grid>
                    </section>
                </div>

                <Grid
                    className="confirm-select"
                    container
                    spacing={0}
                    justify={'center'}>
                    <Grid item xs={11}>
                        <BasicButton
                            className={util.getClassName({
                                'btn-width': true && lang !== 'EN',
                                'en-btn-width': true && lang === 'EN',
                            })}
                            type="primary"
                            disabled={!isSave ? false : true}
                            onClickOfSingleTap={this.submitSave}>
                            <span>
                                {type == 'add'
                                    ? T('b2b_management_submit')
                                    : T('b2b_management_edit')}
                            </span>
                        </BasicButton>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, localData, userCenter, b2bManagement} = state;
    return {
        supplyCenterlist: host.supplyCenterlist,
        SCList: userCenter.SCList,
        platformList: b2bManagement.platformList,
        platformEditList: b2bManagement.platformEditList,
        skuVagueSearchData: host.skuVagueSearchData,
        supplyCenterAlllist: host.supplyCenterAlllist,
        localData: localData,
    };
};

const mapDispatchToProps = {
    openNotification,
    getSCList,
    getEoneStList,
    getPlatfmcodeList,
    getStInforList,
    saveB2bPlatform,
    updateB2bPlatform,
    editB2bPlatform,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddB2bPlatform);
